import { createApiQueryHook, IApiQueryFunction, mapRelationalValue, RelationalValue } from "../../utils";
import { ILocationResource } from "../types";

export type ILocationQueryParameters = {
    location?: RelationalValue<ILocationResource>;
};

export type ILocationQueryResult = ILocationResource;

export const locationQuery: IApiQueryFunction<ILocationQueryParameters> = ({ location }) => {
    if (!location) {
        return;
    }

    return {
        method: "GET",
        url: `/locations/${mapRelationalValue(location)}`,
    };
};

export const useLocationQuery = createApiQueryHook<ILocationQueryParameters, ILocationQueryResult>(locationQuery);
